/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CommitDetails {
    getFixupPrototypeFunction() { return CommitDetails.fixupPrototype; }

    static newInstance(model: Partial<CommitDetails>): CommitDetails {
        let obj = Object.assign(new CommitDetails(), model);
        CommitDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CommitDetails>): CommitDetails {
        if (!model) return null;
        return CommitDetails.newInstance(<CommitDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CommitDetails) {
        if (!obj) return;

        models.CommitDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CommitDetails): boolean {
        Object.setPrototypeOf(obj, CommitDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.commit_date === "string") {
            this.commit_date = new Date(<string><any>this.commit_date);
        }
    }

    /**
     * Hash Identifier for a commit.
     */
    commit_id: string;

    /**
     * Hash Identifier for a parent commit.
     */
    parent_commit_id: string;

    /**
     * Date time at which the commit was committed.
     */
    commit_date: Date;

}
